<app-expansion-list
    (onAdd)="emit_btnAddClick()"
    (onClick)="emit_onClick($event)"
    (onRestore)="emit_onRestore($event)"
    [(tabMode)]="tabMode$$"
    [btnAddData]="btnAddData$$()"
    [btnDeleteData]="btnDeleteData$$()"
    [claimPageList]="claimPageList$$()"
    [itemLines]="itemLines"
    [itemSize]="ItemSize"
    [noClick]="noClick$$()"
    [template]="template"
/>

<ng-template #template let-listItem>
    <div class="chat-row">
        <div class="title-subline-row chat-row__text">
            <!-- Regel 1: (domain › project ·) tijd van het laatste bericht. -->
            <p matListItemLine class="subline">
                @if (context_text(listItem)) {
                    <span>{{ context_text(listItem) }}</span>
                    <span>{{ text.time_separator }}</span>
                }
                <span>{{ listItem?.[lastMessageOn] | appDate:'dateTime' }}</span>
            </p>
            <h3 matListItemTitle>{{ listItem?.[subject] }}</h3>
            <p matListItemLine class="chat-row__last">{{ lastMessage_text(listItem) }}</p>
        </div>
        <div class="chat-row__status">
            @if (listItem?.[closed]) {
                <app-icon name="lock" [matTooltip]="text.closed" [matTooltipPosition]="'left'" />
            }
            @if (listItem?.[unreadCount] > 0) {
                <span class="chat-row__unread" [matTooltip]="text.unread" [matTooltipPosition]="'left'">{{ listItem[unreadCount] }}</span>
            }
        </div>
    </div>
</ng-template>
